import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../../api/Api.js";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const AddCategoryPage = () => {
  const { countryId } = useParams();
  const navigate = useNavigate();
  const IMAGE_BASE_URL =
    process.env.REACT_APP_BASE_URL ||
    "";
  const [getCategoryName, setCategoryName] = useState("");
    const [getCategorySlag, setCategorySlag] = useState("");
      const [getCategoryMeta_title, setCategoryMeta_title] = useState("");
        const [getCategoryMeta_desc, setCategoryMeta_desc] = useState("");
          const [getCategoryMeta_keyword, setCategoryMeta_keyword] = useState("");
            const [getCategoryPage_desc, setCategoryPage_desc] = useState("");

            // =========================
              // MULTIPLE ROWS
              // =========================
              const [multipleRows, setMultipleRows] = useState([
                {
                  miniTitle: "",
                  miniDescription: "",
                  miniImage: null,
                  existingImage: "",
                },
              ]);

  // =========================
  // FETCH SINGLE CATEGORY
  // =========================
  const fetchCategoryById = async () => {
    try {
      const res = await api.get(`/adminHolidays/get-holidays-country-by-id/${countryId}`);

      if (res.data.success) {
        const data = res.data.data;
        console.log(data);
        setCategoryName(data.name);
        setCategorySlag(data.slug);
        setCategoryMeta_title(data.meta_title);
        setCategoryMeta_desc(data.meta_desc);
        setCategoryMeta_keyword(data.meta_keyword);
        setCategoryPage_desc(data.page_desc);
         // If the API returns mini rows, load them.
        // Get multiple rows
      let rows = data.multipleRows ?? data.miniRows ?? [];

      // Convert JSON string into an array
      try {
        while (typeof rows === "string") {
          rows = JSON.parse(rows);
        }
      } catch (parseError) {
        console.error("Multiple rows JSON error:", parseError);
        rows = [];
      }

      // Ensure rows is always an array
      if (!Array.isArray(rows)) {
        rows = [];
      }

      // Set default row if API returns no rows
      if (rows.length === 0) {
        rows = [
          {
            miniTitle: "",
            miniDescription: "",
            miniImage: null,
            existingImage: "",
          },
        ];
      }

      setMultipleRows(rows);
      } else {
        toast.error("Country not found");
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch Country");
    }
  };

  useEffect(() => {
    if (countryId) {
      fetchCategoryById();
    }
  }, [countryId]);


useEffect(() => {
  const slugData = getCategoryName
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");

  setCategorySlag(slugData);
}, [getCategoryName]);

  // =========================
  // UPDATE CATEGORY
  // =========================
 const updateCategory = async () => {
  if (!getCategoryName || !getCategoryName.trim()) {
    toast.error("Country name required");
    return;
  }

  const confirm = await Swal.fire({
    title: "Update Country?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes Update",
    cancelButtonText: "Cancel",
  });

  if (!confirm.isConfirmed) return;

  try {
    const payload = {
      category: getCategoryName,
      slug: getCategorySlag,
      meta_title: getCategoryMeta_title,
      meta_desc: getCategoryMeta_desc,
      meta_keyword: getCategoryMeta_keyword,
      page_desc: getCategoryPage_desc,
    };

    console.log("UPDATE PAYLOAD =>", payload);

    const res = await api.put(
      `/adminHolidays/holidays-update-country/${countryId}`,
      payload
    );

    if (res.data.success) {
      await Swal.fire({
        title: "Success",
        text: "Country Updated Successfully",
        icon: "success",
        confirmButtonText: "OK",
      });

      navigate("/holidays/country/manage-country");
    } else {
      Swal.fire(
        "Error",
        res.data.message || "Failed to update Country",
        "error"
      );
    }
  } catch (error) {
    console.log("FULL ERROR =>", error);
    console.log("RESPONSE =>", error?.response?.data);

    toast.error(
      error?.response?.data?.message || "Server Error"
    );
  }
};

// =========================
  // ADD ROW
  // =========================
  const addMultipleRow = () => {
    setMultipleRows((prevRows) => [
      ...prevRows,
      {
        miniTitle: "",
        miniDescription: "",
        miniImage: null,
        existingImage: "",
      },
    ]);
  };


 // =========================
  // REMOVE ROW
  // =========================
  const removeMultipleRow = async (index) => {
    if (multipleRows.length === 1) {
      toast.error("At least one row is required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Row?",
      text: "Are you sure you want to delete this row?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
    });

    if (!confirm.isConfirmed) return;

    setMultipleRows((prevRows) =>
      prevRows.filter((_, i) => i !== index)
    );
  };

  // =========================
  // HANDLE ROW CHANGE
  // =========================
  const handleMultipleChange = (index, field, value) => {
    setMultipleRows((prevRows) =>
      prevRows.map((row, i) =>
        i === index
          ? {
              ...row,
              [field]: value,
            }
          : row
      )
    );
  };

  const getImageUrl = (image) => {
    if (!image) {
      return "";
    }

    if (
      image.startsWith("http://") ||
      image.startsWith("https://") ||
      image.startsWith("blob:")
    ) {
      return image;
    }

    return `${IMAGE_BASE_URL}/uploads/holidays_packages/${image}`;
  };

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm mb-4 bg-primary-subtle">
        <div className="card-body d-flex justify-content-between">
          <h4>Edit counrty</h4>

          <Link to="/holidays/country/manage-country" className="btn btn-secondary btn-sm">
            <ArrowLeft size={16} /> Back
          </Link>
        </div>
      </div>

      {/* FORM */}
      <div className="card">
        <div className="card-body">

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
              </tr>
            </thead>

            <tbody>

                <tr >
                  <td>
                    <input
                      className="form-control"
                      value={getCategoryName}
                      onChange={(e) =>
                        setCategoryName(e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                      className="form-control"
                      readOnly
                      value={getCategorySlag}
                      onChange={(e) =>
                        setCategorySlag(e.target.value)
                      }
                    />
                  </td>
                </tr>
                
       
            </tbody>
              <thead>
              <tr>
                <th>   <div className="d-flex align-items-center gap-2">
                        <span>Meta Title</span>
                        <small className={`d-block mt-1 ${
                           (getCategoryMeta_title?.length || 0) > 80 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getCategoryMeta_title?.length || 0)}/80 Characters)
                        </small>
                     </div></th>
                <th>
                     <div className="d-flex align-items-center gap-2">
                        <span>Meta Description</span>
                        <small className={`d-block mt-1 ${
                           (getCategoryMeta_desc?.length  || 0)> 160 ? "text-danger" : "text-muted"
                        }`}>
                        ({(getCategoryMeta_desc?.length || 0)}/160 Characters)
                        </small>
                     </div>
                </th>
              </tr>
            </thead>
            
            <tbody>

                <tr >
                  <td>
                    <textarea
                  rows="3" className="form-control" maxLength={80} value={getCategoryMeta_title} onChange={(e) => setCategoryMeta_title(e.target.value)} />
                     {(getCategoryMeta_title?.length || 0) >= 79 && (getCategoryMeta_title?.length || 0) <= 80 && (
                     <small className="text-danger">
                     ⚠️ Almost reached limit
                     </small>
                     )}
                  </td>

                  <td>
                   <textarea className="form-control"  rows="3"  maxLength={160} value={getCategoryMeta_desc} onChange={(e) => setCategoryMeta_desc(e.target.value)} />
               {(getCategoryMeta_desc?.length || 0 )>= 159 && (getCategoryMeta_desc?.length || 0) <= 160 && (
  <small className="text-danger">
    ⚠️ Almost reached limit
  </small>
)}
                  </td>
                </tr>
                
       
            </tbody>
             <thead>
              <tr>
                <th>
                     <div className="d-flex align-items-center gap-2">
               <span>Meta Keyword  </span><small className={`d-block mt-1 ${
                  (getCategoryMeta_keyword?.length || 0 )> 255 ? "text-danger" : "text-muted"
               }`}>
               ({(getCategoryMeta_keyword?.length || 0 )}/255 Characters)
               </small>
               </div>
                </th>
                <th>Page Description</th>
              </tr>
            </thead>
            <tbody>

                <tr >
                  <td>
                    <textarea
                  rows="3" maxLength={255} className="form-control" value={getCategoryMeta_keyword} onChange={(e) => setCategoryMeta_keyword(e.target.value)} ></textarea>
               {(getCategoryMeta_keyword?.length || 0)>= 254 && (getCategoryMeta_keyword?.length || 0) <= 255 && (
               <small className="text-danger">
               ⚠️ Almost reached limit
               </small>
               )}
                  </td>

                  <td>
                    <textarea
                  rows="3"
                      className="form-control"
                      
                      value={getCategoryPage_desc}
                      onChange={(e) =>
                        setCategoryPage_desc(e.target.value)
                      }
                    />
                  </td>
                </tr>
                
       
            </tbody>
          </table>
  {/* MULTIPLE ROWS */}
          <div className="table-responsive">
            <table className="table table-hover table-bordered align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "60px" }}>Sl.No</th>
                  <th>Mini Title</th>
                  <th>Mini Description</th>
                  <th>Mini Image</th>
                  <th style={{ width: "120px" }}>Action</th>
                </tr>
              </thead>

              <tbody>
                {multipleRows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Mini Title"
                        value={row.miniTitle}
                        onChange={(e) =>
                          handleMultipleChange(
                            index,
                            "miniTitle",
                            e.target.value
                          )
                        }
                      />
                    </td>

                    <td>
                      <textarea
                        className="form-control"
                        rows={2}
                        placeholder="Enter Mini Description"
                        value={row.miniDescription}
                        onChange={(e) =>
                          handleMultipleChange(
                            index,
                            "miniDescription",
                            e.target.value
                          )
                        }
                      />
                    </td>

                     <td>
                      
{row.existingImage ? (
  // IF: Existing image available hai
  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    <img
      src={getImageUrl(row.existingImage)}
      alt="Existing"
      style={{
        width: "60px",
        height: "60px",
        objectFit: "contain",
        border: "1px solid #ddd",
        borderRadius: "6px",
        padding: "4px",
        background: "#fff",
      }}
    />

    <input
      type="file"
      className="form-control"
      accept="image/*"
      onChange={(e) => {
        const file = e.target.files?.[0] || null;
        handleMultipleChange(index, "miniImage", file);
      }}
    />
  </div>
) : (
  // ELSE: Existing image nahi hai
  <input
    type="file"
    className="form-control"
    accept="image/*"
    onChange={(e) => {
      const file = e.target.files?.[0] || null;
      handleMultipleChange(index, "miniImage", file);
    }}
  />
)}

{row.miniImage && (
  <small className="text-success d-block mt-1">
    Selected: {row.miniImage.name}
  </small>
)}
                    </td>

                    <td>
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-success btn-sm"
                          onClick={addMultipleRow}
                          title="Add Row"
                        >
                          <i className="fa fa-plus-square" />
                        </button>

                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeMultipleRow(index)}
                          title="Delete Row"
                        >
                          <i className="fa fa-trash" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button className="btn btn-success mt-3" onClick={updateCategory}>
            Update Counrty
          </button>

        </div>
      </div>
    </div>
  );
};

export default AddCategoryPage;